import * as React from 'react';

export function TrashIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 0C4.44772 0 4 0.447715 4 1V2V3H1V5H15V3H12V2V1C12 0.447715 11.5523 0 11 0H5ZM10 2H6V3H10V2ZM3 7H13V13C13 14.1046 12.1046 15 11 15H5C3.89543 15 3 14.1046 3 13V7Z"
        fill="#737a8e"
      />
    </svg>
  );
}
